import React from "react";
import T from "services/lang/LanguageService";
import { easasAlert } from "components/fragments/easas-global-fragment/EasasGlobalAlerts";
import { copyToClipBoard } from "../../dashboard/dataset-info-search/utils";

type CopyTextWithButtonProps = {
  text: string;
  copyableText?: string;
};

const CopyTextWithButton = ({ text, copyableText }: CopyTextWithButtonProps) => {
  const onCopyClick = (copiedText: string) => {
    copyToClipBoard(copiedText).then(() => {
      easasAlert({
        summary: T("alert.copied-to-clipboard"),
        severity: "success",
        detail: copiedText,
        life: 3000,
      });
    });
  };

  return (
    <>
      {text && <span className="ml-2">{text}</span>}
      <i
        className="pi pi-copy cursor-pointer ml-1 mr-2"
        onClick={() => onCopyClick(copyableText || text)}
      />
    </>
  );
};

export default CopyTextWithButton;
